import React from 'react';
import { Drawer } from 'antd';
import { AgentChatPanel } from '@/features/agent-chat';
import { useAppDispatch, useAppSelector } from '@/hooks/reduxHooks';
import { toggleAIAssistant } from '@/store/slices/common/commonSlice';

const Assistant = () => {
  const dispatch = useAppDispatch();
  const handleCloseAssistant = () => {
    dispatch(toggleAIAssistant());
  };

  const { openAIAssistant } = useAppSelector((state) => state.common);
  return (
    <Drawer
      title="KALI AI"
      open={openAIAssistant}
      onClose={handleCloseAssistant}
      width={900}
      bodyStyle={{
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}
    >
      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <AgentChatPanel />
      </div>
    </Drawer>
  );
};

export default Assistant;
